const handleSearchHeader = () => {
  $('.js-search-trigger').on('click', function(event) {
    $('.header__search').toggleClass('is-active');

    event.preventDefault();
  });
}

handleSearchHeader();

const closeSearchHeader = () => {
  $('.header__search-close').on('click', function(event) {
    $('.header__search').removeClass('is-active');

    event.preventDefault();
  });

  $(document).on('click', function(event) {
    const $trigger = $('.header__search.is-active');

    if (! $trigger.length) {
      return;
    }

    $trigger.each(function(index, el) {
      const $this = $(this);

      if($this !== event.target && ! $this.has(event.target).length && ! $('.js-search-trigger').has(event.target).length) {
        $this.removeClass('is-active');
      }
    });
  });
}

closeSearchHeader();

